// queries/useGetModel.ts
"use client";
import { useQuery } from "@tanstack/react-query";
import { fetch } from "libs";
import { GET_MODEL, GET_USER_MODEL } from "api";
import { Model } from "types";

function fetchModel(name: string, endpoint: (name: string) => string): Promise<Model> {
  return fetch(endpoint(name), {
    method: "GET",
  });
}

// React Query hook
export function useGetModel(isUserModelPath: boolean, name?: string, opts = {}) {
  const endpoint = isUserModelPath ? GET_USER_MODEL : GET_MODEL;

  return useQuery({
    queryKey: ["useModel", name, isUserModelPath],
    queryFn: async () => {
      if (!name) {
        throw new Error("Name is required to fetch model");
      }

      const model = await fetchModel(name, endpoint);
      return model;
    },
    enabled: !!name,
    staleTime: 1000 * 600 * 60 * 24,
    ...opts,
  });
}

export default useGetModel;
